export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Aesthetic%20minimalist%20product%20display%20with%20various%20fashion%20items%20including%20leather%20shoes%20woven%20bag%20and%20linen%20scarf%20artistically%20arranged%20on%20warm%20cream%20textured%20surface%20soft%20morning%20sunlight%20streaming%20from%20left%20casting%20delicate%20shadows%20neutral%20earth%20tone%20palette%20editorial%20photography%20clean%20composition%20with%20generous%20negative%20space%20for%20text%20overlay&width=1600&height=900&seq=itaobuy-hero-bg-v4&orientation=landscape"
          alt="Curated fashion products from China sourcing spreadsheet"
          title="Itaobuy Spreadsheet — China Product Shopping Guide"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-start gap-10 lg:gap-16">
          {/* Left: Main Heading */}
          <div className="flex-1 pt-20 md:pt-0 animate-in">
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-semibold text-background-50 leading-tight">
              Itaobuy Spreadsheet
              <br />
              <span className="text-background-50/80 font-normal">China Product</span>
              <br />
              <span className="text-background-50/70 font-light">Shopping Guide</span>
            </h1>
            <p className="mt-6 text-sm md:text-base text-background-50/80 max-w-lg leading-relaxed">
              Discover curated China sourcing spreadsheets with real products, updated listings, and trusted agents — all in one place. The itaobuyspreadsheet system helps you find verified products from China platforms in a simplified, organized format.
            </p>
            <div className="flex flex-wrap gap-3 mt-8">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
              >
                Explore Itaobuy Spreadsheet
                <i className="ri-arrow-right-line ml-2 text-xs" />
              </a>
              <a
                href="#categories"
                className="px-6 py-3 rounded-full border border-background-50/40 text-background-50 text-sm font-medium hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer"
              >
                View Categories
                <i className="ri-arrow-down-line ml-2 text-xs" />
              </a>
            </div>
          </div>

          {/* Right: Supporting text */}
          <div className="lg:w-[380px] pt-6 lg:pt-28 animate-in animate-in-delay-2">
            <p className="text-sm text-background-50/70 leading-relaxed mb-8">
              No confusion. No wasted time. Just structured shopping data organized into clean, filterable spreadsheets. Browse 14 categories — from Shoes to Perfumes — with agent-ready links and verified supplier information.
            </p>
            <a
              href="#how-it-works"
              className="inline-flex items-center gap-2 text-sm text-background-50/90 hover:text-background-50 transition-colors underline underline-offset-4 decoration-background-50/30 hover:decoration-background-50/60"
            >
              Learn how it works
              <i className="ri-arrow-right-line text-xs" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}